import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { ApiService } from '../api.service';

@Component({
  selector: 'app-category',
  templateUrl: './category.component.html',
  styleUrls: ['./category.component.sass']
})
export class CategoryComponent implements OnChanges {
  @Input() cat: string;
  @Input() num: number;
  @Input() pageNum: number;
  @Input() single: boolean;
  @Input() searchBool: boolean;
  @Input() searchVal: string;
  @Input() reload: any;

  firstItem: number

  @Output() singleCat = new EventEmitter()
  @Output() pageTurnerRight = new EventEmitter()
  @Output() pageTurnerLeft = new EventEmitter()

  public items: any = [];
  public prev: boolean = false
  public next: boolean = true
  public lastPage: number
  public bagItems: any = [];
  public loading = true;


  constructor(private apiService: ApiService) { }

  clickHandler = () => {
    this.singleCat.emit()
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.searchBool === true) {
      this.apiService.getFilteredCategoryPosts16(this.cat, this.searchVal, this.pageNum).subscribe( data => {
        this.items = data.results;
        this.lastPage = Math.ceil(data.count/16)
        this.loading = false
        if (data.links['next'] === null) {
          this.next = false
        }
        else {
          this.next = true
        }
        if (data.links['previous'] === null) {
          this.prev = false
        }
        else {
          this.prev = true
        }
      },
        (error)=> {console.log("error", error)})
    }
    
    else if (!this.single && (this.cat !== 'all' && this.cat !== 'free')) {
      this.apiService.getCategoryPosts4(this.cat, this.pageNum).subscribe(data => {
        this.items = data.results;
        this.loading = false

        this.lastPage = Math.ceil(data.count/4)
        if (data.links['next'] === null) {
          this.next = false
        }
        else {
          this.next = true
        }
        if (data.links['previous'] === null) {
          this.prev = false
        }
        else {
          this.prev = true
        }
      },
        (error)=> {console.log("error", error)})
    }

    else if (!this.single && this.cat === 'all') {
      this.apiService.getAllPosts4(this.pageNum).subscribe(data => {
        this.items = data.results;
        this.loading = false
        this.lastPage = Math.ceil(data.count/4)
        if (data.links['next'] === null) {
          this.next = false
        }
        else {
          this.next = true
        }
        if (data.links['previous'] === null) {
          this.prev = false
        }
        else {
          this.prev = true
        }
      },
        (error)=> {console.log("error", error)})
    }

    else if (!this.single && this.cat === 'free') {
      this.apiService.getPricePosts4("0.00", this.pageNum).subscribe(data => {
        this.items = data.results;
        this.loading = false
        this.lastPage = Math.ceil(data.count/4)
        if (data.links['next'] === null) {
          this.next = false
        }
        else {
          this.next = true
        }
        if (data.links['previous'] === null) {
          this.prev = false
        }
        else {
          this.prev = true
        }
      },
        (error)=> {console.log("error", error)})
    }

    else if (this.single && this.cat === 'free') {
      this.apiService.getPricePosts16("0.00", this.pageNum).subscribe(data => {
        this.items = data.results;
        this.loading = false
        this.lastPage = Math.ceil(data.count/16)
        if (data.links['next'] === null) {
          this.next = false
        }
        else {
          this.next = true
        }
        if (data.links['previous'] === null) {
          this.prev = false
        }
        else {
          this.prev = true
        }
      },
        (error)=> {console.log("error", error)})
    }

    else if (this.single && this.cat === 'all') {
      this.apiService.getAllPosts16(this.pageNum).subscribe(data => {
        this.items = data.results;
        this.loading = false

        this.lastPage = Math.ceil(data.count/16)
        if (data.links['next'] === null) {
          this.next = false
        }
        else {
          this.next = true
        }
        if (data.links['previous'] === null) {
          this.prev = false
        }
        else {
          this.prev = true
        }
      },
        (error)=> {console.log("error", error)})
    }

    else {
        this.apiService.getCategoryPosts16(this.cat, this.pageNum).subscribe(data => {
          this.items = data.results;
          this.loading = false

          this.lastPage = Math.ceil(data.count/16)
          if (data.links['next'] === null) {
            this.next = false
          }
          else {
            this.next = true
          }
          if (data.links['previous'] === null) {
            this.prev = false
          }
          else {
            this.prev = true
          }
        },
          (error)=> {console.log("error", error)})
  
    }
  }


  turnPageRight(val, val2, val3) {
    this.pageTurnerRight.emit([val, val2, val3])
  }

  turnPageLeft(val, val2, val3) {
    this.pageTurnerLeft.emit([val, val2, val3])
  }

}
